(() => {
  const storageKey = 'paraDaizaPrivateSaleCollection';
  const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
  const collectionMatch = currentPath.match(/^\/collections\/[^/]+/);
  const isPrivateSaleCollection = document.body.classList.contains('private-sale-template');

  if (isPrivateSaleCollection && collectionMatch) {
    sessionStorage.setItem(storageKey, collectionMatch[0]);
  }

  const privateSalePath = sessionStorage.getItem(storageKey);
  const hasPrivateSaleLink = privateSalePath
    && Array.from(document.links).some((link) => {
      const linkPath = link.pathname.replace(/\/+$/, '') || '/';
      return linkPath === privateSalePath;
    });
  const isProductPage = currentPath.startsWith('/products/')
    || (privateSalePath && currentPath.startsWith(`${privateSalePath}/products/`));
  const isPrivateSaleProduct = privateSalePath && isProductPage && hasPrivateSaleLink;
  const isCartPage = currentPath === '/cart';
  const isPrivateSaleJourney = Boolean(
    privateSalePath
    && (isPrivateSaleCollection || isPrivateSaleProduct || isCartPage)
  );

  if (!isPrivateSaleJourney) {
    sessionStorage.removeItem(storageKey);
  }

  const updateContinueLinks = () => {
    document.querySelectorAll('[data-private-sale-continue]').forEach((link) => {
      link.hidden = !isPrivateSaleJourney;
      if (isPrivateSaleJourney) {
        link.href = privateSalePath;
      }
    });
  };

  updateContinueLinks();
  document.addEventListener('on:cart:add', updateContinueLinks);
  document.addEventListener('on:cart:after-merge', updateContinueLinks);
})();
